// extracted by mini-css-extract-plugin
module.exports = {"titleDescription":"propertyDescriptionItem_titleDescription__3XrFa","line":"propertyDescriptionItem_line__bPESW","arrow":"propertyDescriptionItem_arrow__1AmBU","open":"propertyDescriptionItem_open__1dwYr"};
    if(module.hot) {
      // 1790670300840
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  